export default __webpack_public_path__ + "static/media/dm_nhom_dv_ki_thuat.c80da6a5.xlsx";